/**
 * Show footer scroll-to-top button on scroll
 */

import $ from 'jquery';

((window, document) => {
	const backToTopButton = document.querySelector('.footer-sticky .btn-to-top, .footer_sticky .btn-to-top');
	let scrolledPast = false;

	if (!backToTopButton) {
		return;
	}

	// Show button when scrolled 400px
	function checkScrollPosition() {
		if (!scrolledPast && window.scrollY > 400) {
			scrolledPast = true;
			backToTopButton.classList.add('active');
		} else if (scrolledPast && window.scrollY <= 400) {
			scrolledPast = false;
			backToTopButton.classList.remove('active');
		}
	}

	function scrollToTop() {
		const lastScrollTop = document.documentElement.scrollTop;
		document.getElementById('main-content').setAttribute('tabindex', -1);
		$(document.documentElement).scrollTop(lastScrollTop).animate({ scrollTop: 0 }, 600);
		// document.documentElement.scrollTop = 0;
		return false;
	}

	// Run once on load
	checkScrollPosition();
	
	// Check position on scroll
	window.addEventListener('scroll', checkScrollPosition, { passive: true });

	// Click listener
	backToTopButton.addEventListener('click', scrollToTop);
	
})(window, document);
